"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenGenericMatrix = flattenGenericMatrix;
function flattenGenericMatrix(input) {
    // Check if input is an array
    if (Array.isArray(input)) {
        return input.reduce((acc, item) => {
            // Check if item has customFieldValues and metadata with _id
            if (item.customFieldValues && item.metadata && item.metadata._object_id !== undefined) {
                const id = item.metadata._object_id;
                const fields = item.customFieldValues.reduce((fieldAcc, field) => {
                    fieldAcc[field.key] = field.value;
                    return fieldAcc;
                }, {});
                acc[id] = fields;
            }
            return acc;
        }, {});
    }
    // Return the input as is if it doesn't meet the array condition
    return input;
}
